import React from 'react'
import { Navigate } from 'react-router-dom'

import { CookieStorage } from '@helpers'
import { categoriesApi } from '@services/CategoriesAPI'
import { authCreators } from '@store/ducks/auth'
import { useAppDispatch } from '@store/hooks'

export function Logout() {
	const dispatch = useAppDispatch()

	const cookieStorage = new CookieStorage()

	cookieStorage.removeSessionCookies()

	localStorage.clear()
	dispatch(authCreators.logout())
	dispatch(categoriesApi.util.resetApiState())

	return <Navigate to='/' />
}
